import React from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import PermissionDecoratorV2 from '../../../components/utils/permission/PermissionDecoratorV2';
import {
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
  Box,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * This component replace using GridActionsCellItem / GridActionsCell.
 * We implement our control button + MUI Menu, which replaces showInMenu
 * (creates a menu from actions, rather than simply displaying buttons
 * inside a cell).
 */

interface UserActionsCellProps {
  params: GridRenderCellParams;
}

export function UserActionsCell({ params }: UserActionsCellProps) {
  const { t } = useTranslation('components.users');
  const row = params.row;

  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  return (
    <Box className="mui-actions-cell">
      <IconButton size="small" onClick={handleOpen}>
        <MoreVertIcon fontSize="small" />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        elevation={3}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        slotProps={{
          paper: {
            sx: {
              transform: 'translateX(-100%) !important',
            },
          },
        }}
      >
        <PermissionDecoratorV2 item={'configuration_users_edit_button'}>
          <MenuItem
            onClick={() => {
              handleClose();
              row.onEdit?.();
            }}
          >
            <ListItemIcon>
              <EditIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t('Modifier')}</ListItemText>
          </MenuItem>
        </PermissionDecoratorV2>

        <PermissionDecoratorV2 item={'configuration_users_delete_button'}>
          <MenuItem
            onClick={() => {
              handleClose();
              row.onDelete?.();
            }}
          >
            <ListItemIcon>
              <DeleteIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t('Supprimer')}</ListItemText>
          </MenuItem>
        </PermissionDecoratorV2>
      </Menu>
    </Box>
  );
}
